/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * ScopeType
 * Тип пространства. Клиентское заводит публичная регистрация, контрагентское -
 * онбординг по приглашению заказчика; сменить тип существующего пространства нельзя.
 */
export enum ScopeType {
  Client = "client",
  Counterparty = "counterparty",
}

/**
 * ScopeLegalEntityStatus
 * Статус валидации карточки владельцем пространства.
 */
export enum ScopeLegalEntityStatus {
  InReview = "in_review",
  Confirmed = "confirmed",
  Rejected = "rejected",
}

/** PermissionScope */
export enum PermissionScope {
  Users = "users",
  Products = "products",
  Catalogs = "catalogs",
  Orders = "orders",
  Roles = "roles",
  UserGroups = "user_groups",
  OrderApprovalChains = "order_approval_chains",
  RecipientsAndContacts = "recipients_and_contacts",
  Processes = "processes",
  Assignments = "assignments",
  Warehouses = "warehouses",
  Account = "account",
  Imports = "imports",
  Analytics = "analytics",
  Epd = "epd",
}

/**
 * ParticipationRowStatus
 * Состояние строки коалиции: хранимые состояния участия плюс вычисленное
 * "ожидает активации" - не активирован, а ссылка из приглашения ещё живёт.
 */
export enum ParticipationRowStatus {
  Inactive = "inactive",
  AwaitingActivation = "awaiting_activation",
  Active = "active",
  Deactivated = "deactivated",
}

/**
 * OnboardingState
 * Состояние страницы по ссылке из письма: всегда ровно одно, сервер определяет его сам.
 */
export enum OnboardingState {
  CreateSpace = "create_space",
  JoinSpace = "join_space",
  Confirm = "confirm",
  AddresseeDeactivated = "addressee_deactivated",
  EmailTaken = "email_taken",
  Expired = "expired",
  Revoked = "revoked",
  Accepted = "accepted",
  NotFound = "not_found",
}

/**
 * Module
 * Модуль, по которому клиент подключает контрагента: доставка, склад, поставка.
 */
export enum Module {
  Delivery = "delivery",
  Warehouse = "warehouse",
  Supply = "supply",
}

/** Level */
export enum Level {
  All = "all",
  Allowed = "allowed",
  Responsible = "responsible",
  Group = "group",
  Denied = "denied",
}

/**
 * LegalEntitySubjectType
 * Вид субъекта по реестру: юрлицо или индивидуальный предприниматель
 * (у ИП нет КПП, а вместо ОГРН - ОГРНИП).
 */
export enum LegalEntitySubjectType {
  LegalEntity = "legal_entity",
  IndividualEntrepreneur = "individual_entrepreneur",
}

/**
 * LegalEntityCapability
 * Кем юрлицо может выступать в перевозке.
 */
export enum LegalEntityCapability {
  Carrier = "carrier",
  Shipper = "shipper",
  Consignee = "consignee",
  Forwarder = "forwarder",
}

/** LangsEnum */
export enum LangsEnum {
  RU = "RU",
  EN = "EN",
  PT = "PT",
}

/** InvitationRowStatus */
export enum InvitationRowStatus {
  Sent = "sent",
  Expired = "expired",
  Accepted = "accepted",
  Revoked = "revoked",
}

/**
 * DeliveryScenario
 * Сценарий модуля доставки.
 */
export enum DeliveryScenario {
  InHouse = "in_house",
  Outsource = "outsource",
  Exchange = "exchange",
  Matrix = "matrix",
}

/** CreateInvitationError */
export enum CreateInvitationError {
  UserAlreadyExisting = "user-already-existing",
  InvitationAlreadyExisting = "invitation-already-existing",
  EmailSendingError = "email-sending-error",
  Unknown = "unknown",
}

/**
 * AssignmentStatus
 * Состояние назначения на текущий момент. Отозванное - revoked независимо
 * от дат; у остальных решает окно действия: ещё не началось - scheduled,
 * уже закончилось - expired, иначе - active.
 */
export enum AssignmentStatus {
  Active = "active",
  Scheduled = "scheduled",
  Expired = "expired",
  Revoked = "revoked",
}

/** AddressProvider */
export enum AddressProvider {
  Google = "google",
  Dadata = "dadata",
}

/** Action */
export enum Action {
  Create = "create",
  View = "view",
  Manage = "manage",
  Delete = "delete",
  Export = "export",
}

/** AcceptCounterpartyInvitationSchema */
export interface AcceptCounterpartyInvitationSchema {
  /** Invitation Uuid */
  invitation_uuid: string;
}

/** ActionConfig */
export interface ActionConfig {
  action: Action;
  /** Levels */
  levels: Level[];
  /** Restrictions */
  restrictions?: Restriction[];
}

/** Address */
export interface Address {
  /** As String */
  as_string: string;
  /** Country Name */
  country_name?: string | null;
  /** Region Name */
  region_name?: string | null;
  /** City Name */
  city_name?: string | null;
  /** Street Name */
  street_name?: string | null;
  /** Street Number */
  street_number?: string | null;
  /** Place Name */
  place_name?: string | null;
  /** Postal Code */
  postal_code?: string | null;
  /** Lat */
  lat?: number | null;
  /** Lon */
  lon?: number | null;
}

/** ApplyResetSchema */
export interface ApplyResetSchema {
  /**
   * Password
   * @minLength 8
   */
  password: string;
  /** Repeated Password */
  repeated_password: string;
}

/** BaselineAssignmentImmutableError */
export interface BaselineAssignmentImmutableError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "assignment_baseline_immutable";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** BaselineRoleRedundantError */
export interface BaselineRoleRedundantError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "assignment_baseline_role_redundant";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** Body_uploadScopeFavicon */
export interface BodyUploadScopeFavicon {
  /**
   * Favicon
   * Image file
   * @format binary
   */
  favicon: File;
}

/** Body_uploadScopeLogo */
export interface BodyUploadScopeLogo {
  /**
   * Logo
   * Image file
   * @format binary
   */
  logo: File;
}

/** Body_uploadUserAvatar */
export interface BodyUploadUserAvatar {
  /**
   * Media
   * Image file
   * @format binary
   */
  media: File;
}

/** BulkUserTagsSchema */
export interface BulkUserTagsSchema {
  /**
   * User Ids
   * @minItems 1
   */
  user_ids: number[];
  /**
   * Tag Uids
   * @minItems 1
   */
  tag_uids: string[];
}

/** ChainLinkDTO */
export interface ChainLinkDTO {
  user_group: UserGroupDTO;
  /** Children */
  children?: ChainLinkDTO[];
}

/** ChainLinkSchema */
export interface ChainLinkSchema {
  user_group: UserGroupSchema;
  /** Children */
  children?: ChainLinkSchema[];
}

/** CloneOrderApprovalChainSchema */
export interface CloneOrderApprovalChainSchema {
  /** Name */
  name: string;
}

/** CoalitionLegalEntitySchema */
export interface CoalitionLegalEntitySchema {
  /** Uid */
  uid: string;
  /** Inn */
  inn: string;
  /** Name */
  name: string;
}

/** ConfirmationAlreadySentError */
export interface ConfirmationAlreadySentError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "confirmation_already_sent";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** ConfirmationExpiredError */
export interface ConfirmationExpiredError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "confirmation_expired";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** CounterpartyInvitationAccountMissingError */
export interface CounterpartyInvitationAccountMissingError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "counterparty_invitation_account_missing";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** CounterpartyInvitationAddresseeDeactivatedError */
export interface CounterpartyInvitationAddresseeDeactivatedError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "counterparty_invitation_addressee_deactivated";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** CounterpartyInvitationEmailTakenError */
export interface CounterpartyInvitationEmailTakenError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "counterparty_invitation_email_taken";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** CounterpartyInvitationNotAllowedError */
export interface CounterpartyInvitationNotAllowedError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "counterparty_invitation_not_allowed";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** CounterpartyInvitationNotLiveError */
export interface CounterpartyInvitationNotLiveError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "counterparty_invitation_not_live";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** CreateAssignmentSchema */
export interface CreateAssignmentSchema {
  /** User Id */
  user_id: number;
  /** Role Id */
  role_id: number;
  /** Valid From */
  valid_from?: string | null;
  /** Valid To */
  valid_to?: string | null;
  visibility_rule?: VisibilityRuleSchema | null;
}

/** CreateDictionaryItemDTO */
export interface CreateDictionaryItemDTO {
  /** Title */
  title: string;
}

/** CreateInvitationDTO */
export interface CreateInvitationDTO {
  /** Email */
  email: string;
}

/** CreateOrderApprovalChainSchema */
export interface CreateOrderApprovalChainSchema {
  /** Name */
  name: string;
  head: ChainLinkDTO;
}

/** CreateParticipationSchema */
export interface CreateParticipationSchema {
  /** Модуль, по которому клиент подключает контрагента: доставка, склад, поставка. */
  module: Module;
  /** Inn */
  inn: string;
  /**
   * Contract Number
   * @minLength 1
   */
  contract_number: string;
  /** Contract Date */
  contract_date: string;
  scenario?: DeliveryScenario | null;
}

/** CreateResetSchema */
export interface CreateResetSchema {
  /**
   * Username
   * @format email
   */
  username: string;
}

/** CreateRoleSchema */
export interface CreateRoleSchema {
  /**
   * Name
   * @minLength 1
   */
  name: string;
  /** Permissions */
  permissions: PermissionInput[];
}

/** CreateUserGroupSchema */
export interface CreateUserGroupSchema {
  /** Name */
  name: string;
  /** Cluster */
  cluster?: string | null;
}

/**
 * CustomerCardSchema
 * Заказчик во вкладке «Заказчики»: реквизиты карточки из реестра, без контактов и служебных полей.
 */
export interface CustomerCardSchema {
  /** Name */
  name: string;
  /** Inn */
  inn: string;
  /** Kpp */
  kpp: string | null;
  /** Ogrn */
  ogrn: string | null;
  /** Registration Date */
  registration_date: string | null;
  legal_address: Address | null;
}

/** CustomerParticipationSchema */
export interface CustomerParticipationSchema {
  /** Uid */
  uid: string;
  /** Модуль, по которому клиент подключает контрагента: доставка, склад, поставка. */
  module: Module;
  /** Contract Number */
  contract_number: string | null;
  /** Contract Date */
  contract_date: string | null;
  /**
   * Состояние строки коалиции: хранимые состояния участия плюс вычисленное
   * "ожидает активации" - не активирован, а ссылка из приглашения ещё живёт.
   */
  status: ParticipationRowStatus;
  /** Activated At */
  activated_at: string | null;
}

/** DictionaryItemNotUniqueError */
export interface DictionaryItemNotUniqueError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "dictionary_title_not_unique";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** DictionaryItemSchema */
export interface DictionaryItemSchema {
  /** Uid */
  uid: string;
  /** Title */
  title: string;
  /** DictionaryItemPermissions */
  $permissions: {
    /** Delete */
    delete?: boolean;
  };
}

/** DictionarySchema */
export interface DictionarySchema {
  /** Uid */
  uid: string;
  /** Slug */
  slug: string;
  /** Title */
  title: string;
  /** DictionaryPermissions */
  $permissions: {
    /** View */
    view?: boolean;
    /** Create Item */
    create_item?: boolean;
  };
}

/** EdoProfileUnavailableError */
export interface EdoProfileUnavailableError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "edo_profile_unavailable";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** EmailOccupancySchema */
export interface EmailOccupancySchema {
  /**
   * Is Occupied
   * Занят ли этот email
   */
  is_occupied: boolean;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/** ImageVariant */
export interface ImageVariant {
  /** Url */
  url?: string;
}

/** InvalidEdoParticipantIdError */
export interface InvalidEdoParticipantIdError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "invalid_edo_participant_id";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** InvalidImageFileError */
export interface InvalidImageFileError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "invalid_image_file";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** InvalidInnError */
export interface InvalidInnError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "invalid_inn";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** InvalidMediaContentError */
export interface InvalidMediaContentError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "invalid_media_content";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** InvitationDTO */
export interface InvitationDTO {
  /** Uuid */
  uuid?: string | null;
  /** Email */
  email: string;
  /** Expired At */
  expired_at?: string | null;
  error?: CreateInvitationError | null;
}

/** InvitationExpiredError */
export interface InvitationExpiredError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "invitation_expired";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/**
 * InviteParticipantSchema
 * Окно "Пригласить": один адрес.
 */
export interface InviteParticipantSchema {
  /** Email */
  email: string;
}

export type JsonValue = any;

/** LegalEntitySandboxForbiddenError */
export interface LegalEntitySandboxForbiddenError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "legal_entity_sandbox_forbidden";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** ListRolesSchema */
export interface ListRolesSchema {
  /**
   * Name
   * @minLength 1
   */
  name: string;
  /** Permissions */
  permissions: PermissionOutput[];
  /** Pk */
  pk: number;
  /** Code */
  code: string;
  /** System */
  system: boolean;
  /** RolePermissions */
  $permissions: {
    /** Update */
    update?: boolean;
    /** Delete */
    delete?: boolean;
  };
  /**
   * Модуль, для которого заведена системная роль (из реестра по ко��у); у ролей,
   * собранных в пространстве, - пусто.
   */
  module: Module | null;
}

/** ManageUsersDTO */
export interface ManageUsersDTO {
  /** Id */
  id: number;
}

/** ManageUsersUserGroupDTO */
export interface ManageUsersUserGroupDTO {
  /** Users */
  users: ManageUsersDTO[];
}

/** NotificationChannels */
export interface NotificationChannels {
  /**
   * Email
   * @default true
   */
  email?: boolean;
}

/**
 * OnboardingInvitationSchema
 * Что видит адресат: кто, кого и по какому договору приглашает.
 */
export interface OnboardingInvitationSchema {
  /** Email */
  email: string;
  /**
   * Expires At
   * @format date-time
   */
  expires_at: string;
  /** Модуль, по которому клиент подключает контрагента: доставка, склад, поставка. */
  module: Module;
  /** Contract Number */
  contract_number: string | null;
  /** Contract Date */
  contract_date: string | null;
  client: OnboardingOrganizationSchema;
  counterparty: OnboardingOrganizationSchema;
}

/** OnboardingOrganizationSchema */
export interface OnboardingOrganizationSchema {
  /** Name */
  name: string;
  /** Inn */
  inn: string;
}

/** OrderApprovalChainInUseError */
export interface OrderApprovalChainInUseError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "order_approval_chain_name_in_use";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** OrderApprovalChainNameNotUnique */
export interface OrderApprovalChainNameNotUnique {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "order_approval_chain_name_not_unique";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** OrderApprovalChainUsageDTO */
export interface OrderApprovalChainUsageDTO {
  /** Catalogs */
  catalogs: SimpleCatalogDTO[];
  /** Orders */
  orders: SimpleOrderDTO[];
}

/** OrderServiceUnavailableError */
export interface OrderServiceUnavailableError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "order_service_unavailable";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** OwnerAssignmentForbiddenError */
export interface OwnerAssignmentForbiddenError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "assignment_owner_forbidden";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** ParticipationHasUnfinishedOrdersError */
export interface ParticipationHasUnfinishedOrdersError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "participation_has_unfinished_orders";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** ParticipationNotUniqueError */
export interface ParticipationNotUniqueError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "participation_not_unique";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** ParticipationTransitionError */
export interface ParticipationTransitionError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "participation_transition_forbidden";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** PartyNotActiveError */
export interface PartyNotActiveError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "party_not_active";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** PartyNotFoundError */
export interface PartyNotFoundError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "party_not_found";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** PartyRegistryUnavailableError */
export interface PartyRegistryUnavailableError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "party_registry_unavailable";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** Permission */
export interface PermissionInput {
  permission_scope: PermissionScope;
  /** Rules */
  rules: PermissionRule[];
}

/** Permission */
export interface PermissionOutput {
  permission_scope: PermissionScope;
  /** Rules */
  rules: PermissionRule[];
}

/** PermissionRule */
export interface PermissionRule {
  action: Action;
  /** @default "denied" */
  level?: Level;
}

/** RecordsListGenericSchema[ListRolesSchema] */
export interface RecordsListGenericSchemaListRolesSchema {
  /** Items */
  items: ListRolesSchema[];
  /**
   * Total
   * @default 0
   */
  total?: number;
}

/** RecordsListGenericSchema[RetrieveAssignmentSchema] */
export interface RecordsListGenericSchemaRetrieveAssignmentSchema {
  /** Items */
  items: RetrieveAssignmentSchema[];
  /**
   * Total
   * @default 0
   */
  total?: number;
}

/** RecordsListGenericSchema[RetrieveGroupUserSchema] */
export interface RecordsListGenericSchemaRetrieveGroupUserSchema {
  /** Items */
  items: RetrieveGroupUserSchema[];
  /**
   * Total
   * @default 0
   */
  total?: number;
}

/** RecordsListGenericSchema[RetrieveInvitationSchema] */
export interface RecordsListGenericSchemaRetrieveInvitationSchema {
  /** Items */
  items: AppDomainsInvitationsAppSchemasRetrieveInvitationSchema[];
  /**
   * Total
   * @default 0
   */
  total?: number;
}

/** RecordsListGenericSchema[RetrieveLegalEntitySchema] */
export interface RecordsListGenericSchemaRetrieveLegalEntitySchema {
  /** Items */
  items: RetrieveLegalEntitySchema[];
  /**
   * Total
   * @default 0
   */
  total?: number;
}

/** RecordsListGenericSchema[RetrieveOrderApprovalChainSchema] */
export interface RecordsListGenericSchemaRetrieveOrderApprovalChainSchema {
  /** Items */
  items: RetrieveOrderApprovalChainSchema[];
  /**
   * Total
   * @default 0
   */
  total?: number;
}

/** RecordsListGenericSchema[RetrieveUserGroupSchema] */
export interface RecordsListGenericSchemaRetrieveUserGroupSchema {
  /** Items */
  items: RetrieveUserGroupSchema[];
  /**
   * Total
   * @default 0
   */
  total?: number;
}

/** RecordsListGenericSchema[RetrieveUserSchema] */
export interface RecordsListGenericSchemaRetrieveUserSchema {
  /** Items */
  items: RetrieveUserSchema[];
  /**
   * Total
   * @default 0
   */
  total?: number;
}

/** RefreshTokenSchema */
export interface RefreshTokenSchema {
  /** Refresh Token */
  refresh_token: string;
}

/**
 * RegisterAddresseeSchema
 * Форма онбординга - та же, что у приглашённого сотрудника, плюс название пространства:
 * его задаёт первый приглашённый, при существующем пространстве поле не читается.
 * Адреса в форме нет - логин и почта берутся из приглашения.
 */
export interface RegisterAddresseeSchema {
  /** Invitation Uuid */
  invitation_uuid: string;
  /**
   * Password
   * Строка длиной более 8-ми символов.
   */
  password: string;
  /**
   * First Name
   * @minLength 1
   */
  first_name: string;
  /**
   * Last Name
   * @minLength 1
   */
  last_name: string;
  /**
   * Phone
   * @minLength 1
   */
  phone: string;
  /**
   * Title
   * @minLength 1
   */
  title: string;
  /** Scope Title */
  scope_title?: string | null;
}

/** RegisterInvitedUserSchema */
export interface RegisterInvitedUserSchema {
  /** Invitation Uuid */
  invitation_uuid: string;
  /**
   * Password
   * Строка длиной более 8-ми символов.
   */
  password: string;
  /**
   * First Name
   * @minLength 1
   */
  first_name: string;
  /**
   * Last Name
   * @minLength 1
   */
  last_name: string;
  /**
   * Phone
   * @minLength 1
   */
  phone: string;
  /**
   * Title
   * @minLength 1
   */
  title: string;
}

/** RegisterUserSchema */
export interface RegisterUserSchema {
  /**
   * Username
   * @format email
   */
  username: string;
  /**
   * Password
   * Строка длиной более 8-ми символов.
   */
  password: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Title */
  title: string;
  /**
   * Email
   * @format email
   */
  email: string;
  /**
   * Inn
   * ИНН организации; реквизиты карточки берутся из реестра
   */
  inn: string;
  /** @default {"lang":"RU"} */
  settings?: SelfUserSettings;
}

/** Restriction */
export interface Restriction {
  /** Levels */
  levels: Level[];
  /** Rules */
  rules: RestrictionRule[];
}

/** RestrictionRule */
export interface RestrictionRule {
  scope: PermissionScope;
  action: Action;
  /** Levels */
  levels: Level[];
}

/** RetrieveAssignmentSchema */
export interface RetrieveAssignmentSchema {
  /** Uid */
  uid: string;
  /** User Id */
  user_id: number;
  /** Role Id */
  role_id: number;
  /** Valid From */
  valid_from: string | null;
  /** Valid To */
  valid_to: string | null;
  /** Is Active */
  is_active: boolean;
  /** Is Baseline */
  is_baseline: boolean;
  /** Состояние на текущий момент по серверному времени: active, scheduled, expired, revoked */
  status: AssignmentStatus;
  visibility_rule?: RetrieveVisibilityRuleSchema | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** AssignmentPermissions */
  $permissions: {
    /** View */
    view?: boolean;
    /** Update */
    update?: boolean;
    /** Revoke */
    revoke?: boolean;
  };
}

/**
 * RetrieveCoalitionSchema
 * Вкладка Коалиция одним ответом: строки участий и настройки модулей пространства.
 */
export interface RetrieveCoalitionSchema {
  /** Participations */
  participations: RetrieveParticipationSchema[];
  /** Module Settings */
  module_settings: RetrieveModuleSettingsSchema[];
}

/**
 * RetrieveCustomerSchema
 * Строка «Заказчиков»: пространство заказчика, его карточка и участия организации у него.
 */
export interface RetrieveCustomerSchema {
  /** Scope Id */
  scope_id: number;
  /** Заказчик во вкладке «Заказчики»: реквизиты карточки из реестра, без контактов и служебных полей. */
  legal_entity: CustomerCardSchema;
  /** Participations */
  participations: CustomerParticipationSchema[];
}

/**
 * RetrieveEdoProfileSchema
 * Идентификатор участника ЭДО своего ЮЛ. Хранится в сервисе заказов.
 */
export interface RetrieveEdoProfileSchema {
  /** Fns Participant Id */
  fns_participant_id: string | null;
}

/** RetrieveGroupUserSchema */
export interface RetrieveGroupUserSchema {
  /** Id */
  id: number;
  /** Name */
  name: string;
  avatar: UserAvatarSchema | null;
}

/**
 * RetrieveLegalEntitySchema
 * Карточка ЮЛ, как её видит пространство: + статус валидации.
 */
export interface RetrieveLegalEntitySchema {
  /** Uid */
  uid: string;
  /** Inn */
  inn: string;
  /** Kpp */
  kpp: string | null;
  /** Ogrn */
  ogrn: string | null;
  /** Name */
  name: string;
  /** Full Name */
  full_name: string | null;
  subject_type: LegalEntitySubjectType | null;
  /** Registration Date */
  registration_date: string | null;
  /** Capabilities */
  capabilities: LegalEntityCapability[];
  legal_address: Address | null;
  actual_address: Address | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Статус валидации карточки владельцем пространства. */
  status: ScopeLegalEntityStatus;
}

/** RetrieveModuleSettingsSchema */
export interface RetrieveModuleSettingsSchema {
  /** Модуль, по которому клиент подключает контрагента: доставка, склад, поставка. */
  module: Module;
  scenario: DeliveryScenario | null;
}

/**
 * RetrieveOnboardingSchema
 * Страница по ссылке одним ответом: ветка или причина отказа; реквизиты - только у живой ссылки.
 */
export interface RetrieveOnboardingSchema {
  /** Состояние страницы по ссылке из письма: всегда ровно одно, сервер определяет его сам. */
  state: OnboardingState;
  invitation?: OnboardingInvitationSchema | null;
}

/** RetrieveOrderApprovalChainSchema */
export interface RetrieveOrderApprovalChainSchema {
  /** Uid */
  uid: string;
  /** Name */
  name: string;
  head: ChainLinkSchema | null;
  /** OrderApprovalChainPermissions */
  $permissions: {
    /** View */
    view?: boolean;
    /** Update */
    update?: boolean;
    /** Delete */
    delete?: boolean;
  };
}

/** RetrieveParticipationSchema */
export interface RetrieveParticipationSchema {
  /** Uid */
  uid: string;
  legal_entity: CoalitionLegalEntitySchema;
  /** Модуль, по которому клиент подключает контрагента: доставка, склад, поставка. */
  module: Module;
  /** Contract Number */
  contract_number: string | null;
  /** Contract Date */
  contract_date: string | null;
  /**
   * Состояние строки коалиции: хранимые состояния участия плюс вычисленное
   * "ожидает активации" - не активирован, а ссылка из приглашения ещё живёт.
   */
  status: ParticipationRowStatus;
  last_invitation: AppDomainsCoalitionAppSchemasRetrieveInvitationSchema | null;
  /** Activated At */
  activated_at: string | null;
  /** Deactivated At */
  deactivated_at: string | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** ParticipationPermissions */
  $permissions: {
    /** View */
    view?: boolean;
    /** Invite */
    invite?: boolean;
    /** Deactivate */
    deactivate?: boolean;
    /** Reactivate */
    reactivate?: boolean;
  };
}

/** RetrieveResetSchema */
export interface RetrieveResetSchema {
  /**
   * Expired At
   * @format date-time
   */
  expired_at: string;
}

/** RetrieveRoleSchema */
export interface RetrieveRoleSchema {
  /**
   * Name
   * @minLength 1
   */
  name: string;
  /** Permissions */
  permissions: PermissionOutput[];
  /** Pk */
  pk: number;
  /** Code */
  code: string;
  /** Scope Pk */
  scope_pk: number;
  /** System */
  system: boolean;
  /** RolePermissions */
  $permissions: {
    /** Update */
    update?: boolean;
    /** Delete */
    delete?: boolean;
  };
}

/** RetrieveScopeSchema */
export interface RetrieveScopeSchema {
  /** Pk */
  pk: number;
  /** Title */
  title: string;
  settings: ScopeSettingsOutput;
  company: ScopeCompany;
  logo: ScopeLogoDTO | null;
  favicon: ScopeFaviconDTO | null;
  /** ScopePermissions */
  $permissions: {
    /** Update */
    update?: boolean;
    /** View */
    view?: boolean;
    /** Invite Users */
    invite_users?: boolean;
    /** View Roles */
    view_roles?: boolean;
    /** Create Roles */
    create_roles?: boolean;
    /** View Users */
    view_users?: boolean;
    /** Export Users */
    export_users?: boolean;
    /** View User Groups */
    view_user_groups?: boolean;
    /** Create User Groups */
    create_user_groups?: boolean;
    /** View Order Approval Chains */
    view_order_approval_chains?: boolean;
    /** Create Order Approval Chains */
    create_order_approval_chains?: boolean;
    /** View Coalition */
    view_coalition?: boolean;
    /** Manage Coalition */
    manage_coalition?: boolean;
    /** View Customers */
    view_customers?: boolean;
    /** View Assignments */
    view_assignments?: boolean;
    /** Create Assignments */
    create_assignments?: boolean;
    /** View Analytics */
    view_analytics?: boolean;
    /** View Dictionaries */
    view_dictionaries?: boolean;
  };
}

/** RetrieveSelfScopeSchema */
export interface RetrieveSelfScopeSchema {
  /** Title */
  title: string;
  /**
   * Тип пространства. Клиентское заводит публичная регистрация, контрагентское -
   * онбординг по приглашению заказчика; сменить тип существующего пространства нельзя.
   */
  type: ScopeType;
  settings: ScopeSettingsOutput;
  /** Legal Entity Uid */
  legal_entity_uid?: string | null;
  /** Is Sandbox */
  is_sandbox: boolean;
  logo: ScopeLogoDTO | null;
  favicon: ScopeFaviconDTO | null;
  /** ScopePermissions */
  $permissions: {
    /** Update */
    update?: boolean;
    /** View */
    view?: boolean;
    /** Invite Users */
    invite_users?: boolean;
    /** View Roles */
    view_roles?: boolean;
    /** Create Roles */
    create_roles?: boolean;
    /** View Users */
    view_users?: boolean;
    /** Export Users */
    export_users?: boolean;
    /** View User Groups */
    view_user_groups?: boolean;
    /** Create User Groups */
    create_user_groups?: boolean;
    /** View Order Approval Chains */
    view_order_approval_chains?: boolean;
    /** Create Order Approval Chains */
    create_order_approval_chains?: boolean;
    /** View Coalition */
    view_coalition?: boolean;
    /** Manage Coalition */
    manage_coalition?: boolean;
    /** View Customers */
    view_customers?: boolean;
    /** View Assignments */
    view_assignments?: boolean;
    /** Create Assignments */
    create_assignments?: boolean;
    /** View Analytics */
    view_analytics?: boolean;
    /** View Dictionaries */
    view_dictionaries?: boolean;
  };
}

/** RetrieveSelfUserSchema */
export interface RetrieveSelfUserSchema {
  /** Pk */
  pk: number;
  /** Username */
  username: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Title */
  title: string;
  /** Phone */
  phone: string | null;
  /** Email */
  email: string;
  settings: UserSettingsOutput;
  scope: RetrieveSelfScopeSchema;
  /** Is Confirmed */
  is_confirmed: boolean;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  role: Role;
  avatar: UserAvatarSchema | null;
  /** SelfUserPermissions */
  $permissions: {
    /** View */
    view?: boolean;
    /** Update */
    update?: boolean;
  };
}

/** RetrieveUserGroupSchema */
export interface RetrieveUserGroupSchema {
  /** Uid */
  uid: string;
  /** Name */
  name: string;
  /** Cluster */
  cluster: string | null;
  /** Total Users */
  total_users: number;
  /** Users */
  users: RetrieveGroupUserSchema[] | null;
  /** UserGroupPermissions */
  $permissions: {
    /** View */
    view?: boolean;
    /** Update */
    update?: boolean;
    /** Delete */
    delete?: boolean;
  };
}

/** RetrieveUserSchema */
export interface RetrieveUserSchema {
  /** Pk */
  pk: number;
  /** Username */
  username: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Title */
  title: string;
  /** Phone */
  phone: string | null;
  /** Email */
  email: string;
  settings: UserSettingsOutput;
  /** Is Active */
  is_active: boolean;
  /** Is Confirmed */
  is_confirmed: boolean;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  role: UserRoleSchema | null;
  avatar: UserAvatarSchema | null;
  /** Tags */
  tags: SimpleDictionaryItemDTO[] | null;
  /** UserPermissions */
  $permissions: {
    /** View */
    view?: boolean;
    /** Update */
    update?: boolean;
  };
}

/** RetrieveVisibilityRuleSchema */
export interface RetrieveVisibilityRuleSchema {
  section: PermissionScope;
  /**
   * Conditions
   * @minLength 1
   */
  conditions: VisibilityCondition[];
  /** Uid */
  uid: string;
}

/** Role */
export interface Role {
  /** Pk */
  pk?: number;
  /** Code */
  code: string;
  /** Name */
  name: string;
  scope?: Scope;
  /** Scope Pk */
  scope_pk?: number;
  /** @default "client" */
  scope_type?: ScopeType;
  /**
   * System
   * @default false
   */
  system?: boolean;
  /** Permissions */
  permissions: PermissionOutput[];
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /**  Permissions */
  _permissions: Record<string, boolean>;
}

/** RoleConfig */
export interface RoleConfig {
  /** Scopes */
  scopes: ScopeConfig[];
}

/** RoleNameNotUniqueError */
export interface RoleNameNotUniqueError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "role_name_not_unique";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** Scope */
export interface Scope {
  /** Pk */
  pk?: number;
  /**
   * Title
   * @default ""
   */
  title?: string;
  /** @default {"timezone":0,"currency":"USD","country_code":"RU","mass_unit":"","dimension_unit":"","primary_color":"","theme":"","address_provider":"dadata","address_language_code":"RU"} */
  settings?: ScopeSettingsOutput;
  /** @default {"industry":"","employees_count":"","owner_title":""} */
  company?: ScopeCompany;
  logo?: ScopeLogo | null;
  favicon?: ScopeFavicon | null;
  /** @default "client" */
  type?: ScopeType;
  /** Owner Id */
  owner_id?: number | null;
  /** Legal Entity Uid */
  legal_entity_uid?: string | null;
  /** Is Sandbox */
  is_sandbox?: boolean;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /**  Permissions */
  _permissions: Record<string, boolean>;
}

/** ScopeCompany */
export interface ScopeCompany {
  /**
   * Industry
   * @default ""
   */
  industry?: string;
  /**
   * Employees Count
   * @default ""
   */
  employees_count?: string;
  /**
   * Owner Title
   * @default ""
   */
  owner_title?: string;
}

/** ScopeConfig */
export interface ScopeConfig {
  scope: PermissionScope;
  /** Actions */
  actions: ActionConfig[];
}

/** ScopeFavicon */
export interface ScopeFavicon {
  /** Uid */
  uid?: string;
  /** File Uid */
  file_uid?: string;
  /** Scope Id */
  scope_id: number;
  /**
   * Is Temp
   * @default true
   */
  is_temp?: boolean;
  /**
   * Dt Created
   * @format date-time
   */
  dt_created?: string;
  /** Ext */
  ext?: string | null;
}

/** ScopeFaviconDTO */
export interface ScopeFaviconDTO {
  /** Uid */
  uid: string;
  variants: ScopeFaviconVariantSchema;
}

/** ScopeFaviconVariantSchema */
export interface ScopeFaviconVariantSchema {
  /** size: 32x32 */
  small?: ImageVariant;
  /** size: 96x96 */
  medium?: ImageVariant;
  /** size: 192x192 */
  big?: ImageVariant;
}

/** ScopeLegalEntityNotUniqueError */
export interface ScopeLegalEntityNotUniqueError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "scope_legal_entity_not_unique";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** ScopeLogo */
export interface ScopeLogo {
  /** Uid */
  uid?: string;
  /** File Uid */
  file_uid?: string;
  /** Scope Id */
  scope_id: number;
  /**
   * Is Temp
   * @default true
   */
  is_temp?: boolean;
  /**
   * Dt Created
   * @format date-time
   */
  dt_created?: string;
  /** Ext */
  ext?: string | null;
}

/** ScopeLogoDTO */
export interface ScopeLogoDTO {
  /** Uid */
  uid: string;
  variants: ScopeLogoVariantSchema;
}

/** ScopeLogoVariantSchema */
export interface ScopeLogoVariantSchema {
  /** size: fit-in/209x35 */
  small?: ImageVariant;
  /** size: fit-in/85x85 */
  medium?: ImageVariant;
}

/** ScopeSettings */
export interface ScopeSettingsInput {
  /**
   * Timezone
   * Отклонение от UTC в минутах.
   * @default 0
   */
  timezone?: number;
  /**
   * Currency
   * Трехбуквенный код валюты по ISO 4217.
   * @default "USD"
   */
  currency?: string;
  /**
   * Country Code
   * Код страны по ISO 3166
   * @default "RU"
   */
  country_code?: string;
  /**
   * Mass Unit
   * Единица измерения массы.
   * @default ""
   */
  mass_unit?: string;
  /**
   * Dimension Unit
   * Единица измерения размера.
   * @default ""
   */
  dimension_unit?: string;
  /**
   * Primary Color
   * Значение главного цвета.
   * @default ""
   */
  primary_color?: string;
  /**
   * Theme
   * Название темы оформления.
   * @default ""
   */
  theme?: string;
}

/** ScopeSettings */
export interface ScopeSettingsOutput {
  /**
   * Timezone
   * Отклонение от UTC в минутах.
   * @default 0
   */
  timezone?: number;
  /**
   * Currency
   * Трехбуквенный код валюты по ISO 4217.
   * @default "USD"
   */
  currency?: string;
  /**
   * Country Code
   * Код страны по ISO 3166
   * @default "RU"
   */
  country_code?: string;
  /**
   * Mass Unit
   * Единица измерения массы.
   * @default ""
   */
  mass_unit?: string;
  /**
   * Dimension Unit
   * Единица измерения размера.
   * @default ""
   */
  dimension_unit?: string;
  /**
   * Primary Color
   * Значение главного цвета.
   * @default ""
   */
  primary_color?: string;
  /**
   * Theme
   * Название темы оформления.
   * @default ""
   */
  theme?: string;
  /** Провайдер адресов */
  address_provider: AddressProvider;
  /**
   * Address Language Code
   * Язык для провайдера адресов
   */
  address_language_code: string;
}

/** SelfAssignmentChangeForbiddenError */
export interface SelfAssignmentChangeForbiddenError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "assignment_self_change_forbidden";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** SelfUserSettings */
export interface SelfUserSettings {
  /** @default "RU" */
  lang?: LangsEnum;
}

/** SignInResponseSchema */
export interface SignInResponseSchema {
  /** Access Token */
  access_token: string;
  /**
   * Access Token Expire
   * @format date-time
   */
  access_token_expire: string;
  /** Refresh Token */
  refresh_token: string;
  /**
   * Refresh Token Expire
   * @format date-time
   */
  refresh_token_expire: string;
}

/** SignInSchema */
export interface SignInSchema {
  /**
   * Username
   * Логин пользователя (почта)
   */
  username: string;
  /**
   * Password
   * Пароль
   */
  password: string;
}

/** SimpleCatalogDTO */
export interface SimpleCatalogDTO {
  /** Uid */
  uid: string;
  /** Name */
  name: string;
}

/** SimpleDictionaryItemDTO */
export interface SimpleDictionaryItemDTO {
  /** Uid */
  uid: string;
  /** Title */
  title: string;
}

/** SimpleOrderDTO */
export interface SimpleOrderDTO {
  /** Uid */
  uid: string;
}

/** SystemDictionarySlugs */
export type SystemDictionarySlugs = "tags";

/** UpdateAssignmentSchema */
export interface UpdateAssignmentSchema {
  /** Role Id */
  role_id?: number;
  /** Valid From */
  valid_from?: string | null;
  /** Valid To */
  valid_to?: string | null;
  /** Visibility Rule */
  visibility_rule?: VisibilityRuleSchema | null;
}

/** UpdateEdoProfileSchema */
export interface UpdateEdoProfileSchema {
  /** Fns Participant Id */
  fns_participant_id?: string | null;
}

/** UpdateRoleSchema */
export interface UpdateRoleSchema {
  /**
   * Name
   * @minLength 1
   */
  name: string;
  /** Permissions */
  permissions: PermissionInput[];
}

/** UpdateScopeSchema */
export interface UpdateScopeSchema {
  /** Title */
  title: string;
  settings: ScopeSettingsInput;
  company: ScopeCompany;
  /** Logo Uid */
  logo_uid?: string | null;
  /** Favicon Uid */
  favicon_uid?: string | null;
}

/** UpdateSelfPasswordSchema */
export interface UpdateSelfPasswordSchema {
  /** Current Password */
  current_password: string;
  /** New Password */
  new_password: string;
}

/** UpdateSelfUserSchema */
export interface UpdateSelfUserSchema {
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Title */
  title: string;
  /**
   * Email
   * @format email
   */
  email: string;
  /** Phone */
  phone: string;
  settings: SelfUserSettings;
}

/** UpdateUserGroupSchema */
export interface UpdateUserGroupSchema {
  /** Name */
  name: string;
  /** Cluster */
  cluster?: string | null;
}

/** UpdateUserSchema */
export interface UpdateUserSchema {
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Title */
  title: string;
  /** Phone */
  phone: string;
  /** Email */
  email: string;
  settings: UserSettingsInput;
  /** Is Active */
  is_active: boolean;
  /** Tag Uids */
  tag_uids?: string[];
}

/** UserAvatarSchema */
export interface UserAvatarSchema {
  /** Uid */
  uid: string;
  variants: UserAvatarVariantsSchema;
}

/** UserAvatarVariantsSchema */
export interface UserAvatarVariantsSchema {
  /** size: 32x32 */
  small?: ImageVariant;
  /** size: 90x90 */
  medium?: ImageVariant;
  /** size: 320x320 */
  big?: ImageVariant;
}

/** UserEmailAlreadyConfirmed */
export interface UserEmailAlreadyConfirmed {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "user_email_already_confirmed";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** UserEmailNotUniqueError */
export interface UserEmailNotUniqueError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "user_email_not_unique";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** UserExportResponseSchema */
export interface UserExportResponseSchema {
  /**
   * Filename
   * Имя файла экспорта сотрудников
   */
  filename: string;
}

/** UserGroupClusterNotUniqueError */
export interface UserGroupClusterNotUniqueError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "user_group_cluster_not_unique";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** UserGroupDTO */
export interface UserGroupDTO {
  /** Uid */
  uid: string;
}

/** UserGroupInUseError */
export interface UserGroupInUseError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "user_group_in_use";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** UserGroupNameNotUniqueError */
export interface UserGroupNameNotUniqueError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "user_group_name_not_unique";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** UserGroupNotUniqueInOrderApprovalChain */
export interface UserGroupNotUniqueInOrderApprovalChain {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "user_group_not_unique_in_order_approval_chain";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** UserGroupSchema */
export interface UserGroupSchema {
  /** Uid */
  uid: string;
  /** Name */
  name: string;
  /** Total Users */
  total_users: number;
  /** Users */
  users: RetrieveGroupUserSchema[];
}

/** UserNotificationSettings */
export interface UserNotificationSettings {
  /** @default {"email":true} */
  orders_change_status?: NotificationChannels;
  /** @default {"email":true} */
  orders_for_approval?: NotificationChannels;
}

/** UserPhoneNotUniqueError */
export interface UserPhoneNotUniqueError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "user_phone_not_unique";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** UserRoleSchema */
export interface UserRoleSchema {
  /** Pk */
  pk: number;
  /** Code */
  code: string;
  /** Name */
  name: string;
}

/** UserSettings */
export interface UserSettingsInput {
  /** @default "RU" */
  lang?: LangsEnum;
  /**
   * Timezone
   * Отклонение от UTC в минутах. Значение этого параметра устанавливается через аналогичное значение для scope.
   * @default 0
   */
  timezone?: number;
  /** @default {"orders_change_status":{"email":true},"orders_for_approval":{"email":true}} */
  notifications?: UserNotificationSettings;
}

/** UserSettings */
export interface UserSettingsOutput {
  /** @default "RU" */
  lang?: LangsEnum;
  /**
   * Timezone
   * Отклонение от UTC в минутах. Значение этого параметра устанавливается через аналогичное значение для scope.
   * @default 0
   */
  timezone?: number;
  /** @default {"orders_change_status":{"email":true},"orders_for_approval":{"email":true}} */
  notifications?: UserNotificationSettings;
}

/** UsernameNotUniqueError */
export interface UsernameNotUniqueError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "user_username_not_unique";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}

/**
 * VisibilityCondition
 * Одно условие правила: значение атрибута объекта против списков значений.
 *
 * include - объект проходит, если значение атрибута входит хотя бы в одно
 * из перечисленных.
 * exclude - объект отбрасывается, если значение входит в перечисленные.
 */
export interface VisibilityCondition {
  /**
   * Attribute
   * @minLength 1
   */
  attribute: string;
  /**
   * Include
   * @default []
   */
  include?: JsonValue[];
  /**
   * Exclude
   * @default []
   */
  exclude?: JsonValue[];
}

/** VisibilityRuleSchema */
export interface VisibilityRuleSchema {
  section: PermissionScope;
  /**
   * Conditions
   * @minLength 1
   */
  conditions: VisibilityCondition[];
}

/** _Source */
export interface Source {
  /** Pointer */
  pointer?: string | null;
  /** Header */
  header?: string | null;
  /** Parameter */
  parameter?: string | null;
}

/** RetrieveInvitationSchema */
export interface AppDomainsCoalitionAppSchemasRetrieveInvitationSchema {
  /** Email */
  email: string;
  status: InvitationRowStatus;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Expires At
   * @format date-time
   */
  expires_at: string;
}

/** RetrieveInvitationSchema */
export interface AppDomainsInvitationsAppSchemasRetrieveInvitationSchema {
  /** Uuid */
  uuid: string;
  /** Email */
  email: string;
  /**
   * Expired At
   * @format date-time
   */
  expired_at: string;
}

/** CounterpartyInvitationAlreadyLiveError */
export interface CounterpartyInvitationAlreadyLiveError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "counterparty_invitation_already_live";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** ModuleSettingsNotUniqueError */
export interface ModuleSettingsNotUniqueError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "module_settings_not_unique";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** LegalEntityInnImmutableError */
export interface LegalEntityInnImmutableError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "legal_entity_inn_immutable";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** LegalEntityInnNotUniqueError */
export interface LegalEntityInnNotUniqueError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "legal_entity_inn_not_unique";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** DeletedUserGroupInOrderApprovalChainError */
export interface DeletedUserGroupInOrderApprovalChainError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "deleted_user_group_in_order_approval_chain";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** RoleInUseError */
export interface RoleInUseError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "role_in_use";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** PoaStatus */
export enum PoaStatus {
  Active = "active",
  Revoked = "revoked",
  Expired = "expired",
}

/** CreatePoaSchema */
export interface CreatePoaSchema {
  number: string;
  internal_number?: string | null;
  issued_on: string;
  valid_until: string;
  representative_last_name: string;
  representative_first_name: string;
  representative_middle_name?: string | null;
  representative_inn: string;
  representative_snils: string;
  representative_position?: string | null;
  is_primary?: boolean;
}

/** UpdatePoaSchema */
export interface UpdatePoaSchema {
  number?: string;
  internal_number?: string | null;
  issued_on?: string;
  valid_until?: string;
  representative_last_name?: string;
  representative_first_name?: string;
  representative_middle_name?: string | null;
  representative_inn?: string;
  representative_snils?: string;
  representative_position?: string | null;
  is_primary?: true;
  status?: "revoked";
}

/** RetrievePoaSchema */
export interface RetrievePoaSchema {
  uid: string;
  principal_le_uid: string;
  participation_uid: string | null;
  is_primary: boolean;
  number: string;
  internal_number: string | null;
  issued_on: string;
  valid_until: string;
  representative_last_name: string;
  representative_first_name: string;
  representative_middle_name: string | null;
  representative_inn: string;
  representative_snils: string;
  representative_position: string | null;
  status: PoaStatus;
  is_effective: boolean;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}
